import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;
// Test
Object.defineProperty(window, 'jQuery', {
    configurable: true,
    get: function () {
        return jQuery;
    },
    set: function () {
        console.warn('jQuery wurde versucht zu überschreiben – blockiert.');
    }
});
